export const withDocumentNodeId = (documentId: number | string, nodeId: string) =>
  [documentId, nodeId].join('~');

export const getDocumentAndNodeId = (
  documentNodeId: string,
): { nodeId: string; documentId: number } | null => {
  try {
    const [documentId, nodeId] = documentNodeId.trim().split('~');

    return {
      nodeId,
      documentId: parseInt(documentId, 10),
    };
  } catch (error) {
    return null;
  }
};
